import React from 'react';
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";
import KnaekPrimaryButton from "../../AppComponents/KnaekPrimaryButton";
import {useHandleLinkClick} from '../../../hooks/useHandleLinkClick';
import KnaekPrimaryButtonNoPadding from "../../AppComponents/KnaekPrimaryButtonNoPadding";

export default function PricingCard() {
    const handleLinkClick = useHandleLinkClick();

    const initStrings = {
        heading3: stringsTranslate(appWords.prices),
        subheading3: stringsTranslate(appWords.at_knaek_you_dont_have_to_spend_a_fortune_to_get_promoted),
        playImg3: "/assets/images/studentkorting/kossten1.png",
        contactUs: stringsTranslate(appWords.contact_us),
        pricingBasic: stringsTranslate(appWords.pricing_card_basic),
        pricingStandard: stringsTranslate(appWords.pricing_card_standard),
        pricingPremium: stringsTranslate(appWords.pricing_card_premium),
        pricingPayAsYouGo: stringsTranslate(appWords.pricing_card_pay_as_you_go),
        pricingEuroPerMonth: stringsTranslate(appWords.pricing_euro_per_month),
        without_btw: stringsTranslate(appWords.without_btw),
        pricingEuroPerCoupon: stringsTranslate(appWords.pricing_euro_per_coupon),
        pricingMaximumNumberOfBranches: stringsTranslate(appWords.pricing_maximum_number_of_branches),
        pricingMaximumNumberOfCoupons: stringsTranslate(appWords.pricing_minimum_number_of_coupons),
        pricingMaximumNumberOfCouponsPerYear: stringsTranslate(appWords.pricing_maximum_number_of_coupons_per_year),
        pricingAnnualAdvertisingCredit: stringsTranslate(appWords.pricing_annual_advertising_credit),
        pricingUnlimited: stringsTranslate(appWords.pricing_unlimited),
        pricingAtJoppboard: stringsTranslate(appWords.pricing_at_joppboard),
        maximum_number_of_simultaneous_coupon: stringsTranslate(appWords.maximum_number_of_simultaneous_coupon),
        app_position: stringsTranslate(appWords.app_position),
        own_logo_atmosphere: stringsTranslate(appWords.own_logo_atmosphere),
        monthly_statistics: stringsTranslate(appWords.monthly_statistics),
        referral_code: stringsTranslate(appWords.referral_code),
        low: stringsTranslate(appWords.low),
        high: stringsTranslate(appWords.high),
        yes: stringsTranslate(appWords.yes),
        maximum_duration: stringsTranslate(appWords.maximum_duration),
        month: stringsTranslate(appWords.month),
    }

    const textStyles = {
        fontWeight: '600',
        fontSize: '0.8rem',
    }
    const pricingCards = [
        {
            title: "Free",
            price: '0,00',
            text1: initStrings.pricingEuroPerMonth,
            text2: `${initStrings.pricingMaximumNumberOfBranches}:`,
            text3: 1,
            text4: `${initStrings.pricingMaximumNumberOfCouponsPerYear}:`,
            text5: 100,
            text6: `${initStrings.pricingAnnualAdvertisingCredit}:`,
            text7: initStrings.pricingAtJoppboard,
            text8: 249,
            option3: {text: initStrings.maximum_number_of_simultaneous_coupon, value: 1},
            option4: {text: initStrings.app_position, value: initStrings.low},
            option5: {text: initStrings.own_logo_atmosphere, value: '-'},
            option6: {text: initStrings.monthly_statistics, value: '-' },
            option7: {text: initStrings.referral_code, value: '-'},
        },
        {
            title: initStrings.pricingBasic,
            price: '10,00',
            text1: initStrings.pricingEuroPerMonth,
            text2: `${initStrings.pricingMaximumNumberOfBranches}:`,
            text3: 2,
            text4: `${initStrings.pricingMaximumNumberOfCouponsPerYear}:`,
            text5: 200,
            text6: `${initStrings.pricingAnnualAdvertisingCredit}:`,
            text7: initStrings.pricingAtJoppboard,
            text8: 249,
            option3: {text: initStrings.maximum_number_of_simultaneous_coupon, value: 1},
            option4: {text: initStrings.app_position, value: initStrings.high},
            option5: {text: initStrings.own_logo_atmosphere, value: initStrings.yes},
            option6: {text: initStrings.monthly_statistics, value: initStrings.yes },
            option7: {text: initStrings.referral_code, value: initStrings.yes},
        },
        {
            title: initStrings.pricingStandard,
            price: '50,00',
            text1: initStrings.pricingEuroPerMonth,
            text2: `${initStrings.pricingMaximumNumberOfBranches}:`,
            text3: 10,
            text4: `${initStrings.pricingMaximumNumberOfCouponsPerYear}:`,
            text5: 600,
            text6: `${initStrings.pricingAnnualAdvertisingCredit}:`,
            text7: initStrings.pricingAtJoppboard,
            text8: 249,
            isHighlighted: true,
            option3: {text: initStrings.maximum_number_of_simultaneous_coupon, value: 1},
            option4: {text: initStrings.app_position, value: initStrings.high},
            option5: {text: initStrings.own_logo_atmosphere, value: initStrings.yes},
            option6: {text: initStrings.monthly_statistics, value: initStrings.yes },
            option7: {text: initStrings.referral_code, value: initStrings.yes},
        },
        {
            title: initStrings.pricingPremium,
            price: '190,00',
            text1: initStrings.pricingEuroPerMonth,
            text2: `${initStrings.pricingMaximumNumberOfBranches}:`,
            text3: initStrings.pricingUnlimited,
            text4: `${initStrings.pricingMaximumNumberOfCouponsPerYear}:`,
            text5: initStrings.pricingUnlimited,
            text6: `${initStrings.pricingAnnualAdvertisingCredit}:`,
            text7: initStrings.pricingAtJoppboard,
            text8: 249,
            option3: {text: initStrings.maximum_number_of_simultaneous_coupon, value: 2},
            option4: {text: initStrings.app_position, value: initStrings.high},
            option5: {text: initStrings.own_logo_atmosphere, value: initStrings.yes},
            option6: {text: initStrings.monthly_statistics, value: initStrings.yes },
            option7: {text: initStrings.referral_code, value: initStrings.yes},
        },
        {
            title: initStrings.pricingPayAsYouGo,
            price: '2,50',
            text1: initStrings.pricingEuroPerCoupon,
            text2: `${initStrings.pricingMaximumNumberOfBranches}:`,
            text3: initStrings.pricingUnlimited,
            text4: `${initStrings.pricingMaximumNumberOfCoupons}:`,
            text5: 50,
            option3: {text: initStrings.maximum_duration, value: 1 +' '+ initStrings.month},
            option4: {text: initStrings.app_position, value: initStrings.high},
            option5: {text: initStrings.own_logo_atmosphere, value: initStrings.yes},
            option6: {text: initStrings.monthly_statistics, value: initStrings.yes },
            option7: {text: initStrings.referral_code, value: initStrings.yes},
        },
    ]

    return (

        <section className="section">
            <div className="container-fluid">

                {/* Pricing section */}
                <div className="row justify-content-center ">
                    <div className="col-12 text-center d-none d-md-inline">
                        <h2 className={"m-3"}>{initStrings.heading3}</h2>
                    </div>

                    {/* Cards */}
                    <div className="d-flex flex-wrap justify-content-center w-100 mx-lg-4 mx-md-3 mx-2 mt-5 mt-lg-0 mt-md-0">
                        {pricingCards.map((pricing, idx) =>
                            <div
                                key={`pricing-keys-${idx}`}
                                className="pricing-card-wrapper"
                            >
                                <div
                                    className="card border-0 py-2 shadow h-100"
                                    style={{
                                        borderRadius: '16px',
                                        backgroundColor: pricing?.isHighlighted ? '#faeaf4' : undefined,
                                        minHeight: '525px',
                                    }}
                                >
                                    <a className="cursor-pointer" onClick={() => handleLinkClick("/contact")}>
                                        <div className="card-body text-center">
                                            <h3 className="mb-5" style={{fontSize: '1.5rem'}}>{pricing.title}</h3>
                                            <h1 className="mb-4"
                                                style={{fontSize: '3rem', fontWeight: '600'}}>{pricing.price}</h1>
                                            <p style={textStyles}>{pricing.text1}</p>
                                            <p style={textStyles}>{initStrings.without_btw}</p>
                                            <KnaekPrimaryButtonNoPadding title={initStrings.contactUs} className="my-5 p-4 px-2"/>
                                            <p style={textStyles}>{pricing.text2}</p>
                                            <p className="mb-3"
                                               style={{color: '#D44F9E', ...textStyles}}>{pricing.text3}</p>
                                            <p style={textStyles}>{pricing.text4}</p>
                                            <p className="mb-3"
                                               style={{color: '#D44F9E', ...textStyles}}>{pricing.text5}</p>

                                            <p style={textStyles}>{pricing.option3.text}</p>
                                            <p className="mb-3"
                                               style={{color: '#D44F9E', ...textStyles}}>{pricing.option3.value}</p>

                                            <p style={textStyles}>{pricing.option4.text}</p>
                                            <p className="mb-3"
                                               style={{color: '#D44F9E', ...textStyles}}>{pricing.option4.value}</p>

                                            <p style={textStyles}>{pricing.option5.text}</p>
                                            <p className="mb-3"
                                               style={{color: '#D44F9E', ...textStyles}}>{pricing.option5.value}</p>

                                            <p style={textStyles}>{pricing.option6.text}</p>
                                            <p className="mb-3"
                                               style={{color: '#D44F9E', ...textStyles}}>{pricing.option6.value}</p>

                                            <p style={textStyles}>{pricing.option7.text}</p>
                                            <p className="mb-3"
                                               style={{color: '#D44F9E', ...textStyles}}>{pricing.option7.value}</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>


                </div>
            </div>
        </section>
    );
}
